import React, { useEffect, useState, Fragment } from "react";
import AdminTable from "../utlis/AdminTable";
import { IconButton, Tooltip } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import Loader from "src/components/loader/Loader";
import MoreMenu from "../utlis/MoreMenu";
import { useDispatch } from "react-redux";
import { showAlert } from "src/redux/slices/AlertSlice";
import { get, del } from "src/services/content.service";
import { useTranslation } from "react-i18next";
import GroupDialog from "./GroupDialog";

const AdminGroups = () => {
    const [loading, setLoading] = useState(false);
    const [rows, setRows] = useState([]);
    const [groups, setGroups] = useState([]);
    const [selected, setSelected] = useState([]);
    const [selectedGroup, setSelectedGroup] = useState(null);
    const [showDialog, setShowDialog] = useState(false);
    const { t } = useTranslation();

    const dispatch = useDispatch();

    const TABLE_HEAD = [
        { id: "Id", label: t("Group.AdminGroups.table.headers.id"), alignRight: false },
        { id: "Name", label: t("Group.AdminGroups.table.headers.name"), alignRight: false },
        { id: "UsersCount", label: t("Group.AdminGroups.table.headers.usersCount"), alignRight: false },
        { id: "ContentsCount", label: t("Group.AdminGroups.table.headers.contentsCount"), alignRight: false },
        { id: "More", alignRight: true },
    ];

    const fetchGroups = async () => {
        setLoading(true);
        try {
            const res = await get(dispatch, "/api/accounts/groups/");
            console.log(res.data);
            setGroups(res.data);
        } catch (err) {
            dispatch(showAlert({ message: err, severity: "error" }));
        } finally {
            setLoading(false);
        }
    };

    const deleteGroups = async (ids) => {
        try {
            setLoading(true);
            for (const id of ids) {
                await del(dispatch, `/api/accounts/groups/${id}/delete/`);
            }
            setGroups(groups.filter((g) => !ids.includes(g.id)));
            setSelected([]);
        } catch (err) {
            dispatch(showAlert({ message: err, severity: "error" }));
        } finally {
            setLoading(false);
        }
    };

    const openDetails = (group) => {
        setSelectedGroup(group);
        setShowDialog(true);
    };

    useEffect(() => {
        if (groups.length) {
            setRows(
                groups.map((group) => ({
                    Id: group.id,
                    Name: group.name,
                    UsersCount: group.users_count,
                    ContentsCount: group.contents_count,
                    More: (
                        <MoreMenu
                            options={[
                                {
                                    label: t("buttonCommons.details"),
                                    icon: <VisibilityIcon />,
                                    handler: () => openDetails(group),
                                },
                                {
                                    label: t("buttonCommons.delete"),
                                    icon: <DeleteIcon />,
                                    handler: () => deleteGroups([group.id]),
                                },
                            ]}
                        />
                    ),
                }))
            );
        }
    }, [groups]);

    useEffect(() => {
        fetchGroups();
    }, []);

    return (
        <Fragment>
            {loading ? (
                <Loader />
            ) : (
                <Fragment>
                    <GroupDialog
                        open={showDialog}
                        onClose={() => setShowDialog(false)}
                        group={selectedGroup}
                    />
                    <AdminTable
                        searchPlaceholder={t("AdminTableCommons.searchPlaceholder")}
                        headers={TABLE_HEAD}
                        rows={rows}
                        selection={{
                            selected: selected,
                            setSelected: setSelected,
                        }}
                        showChildrenWhenSelected={true}
                        contextMenuOptions={[
                            {
                                label: t("buttonCommons.delete"),
                                icon: <DeleteIcon />,
                                handler: (id) => deleteGroups([groups[id].id]),
                            },
                        ]}
                    >
                        <Tooltip title={t("buttonCommons.delete")}>
                            <IconButton
                                color="primary"
                                aria-label={t("AdminTableCommons.deleteSelected")}
                                component="span"
                                onClick={() => deleteGroups(selected)}
                            >
                                <DeleteIcon />
                            </IconButton>
                        </Tooltip>
                    </AdminTable>
                </Fragment>
            )}
        </Fragment>
    );
};

export default AdminGroups;
